import type { StoryCategory, CopyrightType, StoryStatus } from "../../types/models";

// Story categories (all 36 categories, sorted alphabetically A-Z)
export const STORY_CATEGORIES: StoryCategory[] = [
  "Action",
  "Adventure",
  "BooksAndReviews",
  "Career",
  "ChickLit",
  "CollegeLife",
  "Comedy",
  "Culture",
  "Drama",
  "Education",
  "Fantasy",
  "FanFiction",
  "Finance",
  "Food",
  "GeneralFiction",
  "HealthAndFitness",
  "Historical",
  "Horror",
  "Lifestyle",
  "MentalHealth",
  "Mystery",
  "NonFiction",
  "Paranormal",
  "PersonalGrowth",
  "Poetry",
  "Religion",
  "Romance",
  "ScienceFiction",
  "ShortStory",
  "Tech",
  "Thriller",
  "Travel",
  "Urban",
  "Western",
  "YoungAdult",
  "Other",
];

// Copyright types with descriptions
export const COPYRIGHT_TYPES = [
  {
    value: "All Rights Reserved",
    label: "All Rights Reserved",
    description: "You do not allow your work to be used or adapted in any way without your permission.",
  },
  {
    value: "Public Domain",
    label: "Public Domain",
    description: "This allows anyone to use your story for any purpose — they could freely print, sell, or turn your story into a movie.",
  },
  {
    value: "Creative Commons Attribution",
    label: "Creative Commons (CC) Attribution",
    description: "You hold some rights to your story but allow for things like translation or adaptations with credit back to you.",
  },
  {
    value: "Creative Commons Attribution-NonCommercial",
    label: "(CC) Attrib. NonCommercial",
    description: "This license lets others remix, adapt, and build upon your work non-commercially with credit back to you.",
  },
  {
    value: "Creative Commons Attribution-NonCommercial-NoDerivs",
    label: "(CC) Attrib. NonComm. NoDerivs",
    description: "This license allows others to share your unaltered work with others as long as you get credit.",
  },
  {
    value: "Creative Commons Attribution-NonCommercial-ShareAlike",
    label: "(CC) Attrib. NonComm. ShareAlike",
    description: "This lets others adapt, and build upon your work non-commercially, as long as you are credited and the same terms are applied.",
  },
  {
    value: "Creative Commons Attribution-ShareAlike",
    label: "(CC) Attribution-ShareAlike",
    description: "This lets others adapt and build on your work, even for commercial purposes, as long as you are credited and the same terms are applied.",
  },
  {
    value: "Creative Commons Attribution-NoDerivs",
    label: "(CC) Attribution-NoDerivs",
    description: "This lets others reuse your work for any purpose but it cannot be altered and you must be credited.",
  },
] as const;

// Target Audience options
export const TARGET_AUDIENCE_OPTIONS = [
  { value: "Young Adult", label: "Young Adult (13-18 years of age)" },
  { value: "New Adult", label: "New Adult (18-25 years of age)" },
  { value: "Adult", label: "Adult (25+ years of age)" },
] as const;

// Language options (common languages)
export const LANGUAGE_OPTIONS = [
  "English",
  "Spanish",
  "French",
  "German",
  "Italian",
  "Portuguese",
  "Russian",
  "Chinese",
  "Japanese",
  "Korean",
  "Arabic",
  "Hindi",
  "Dutch",
  "Turkish",
  "Polish",
  "Vietnamese",
  "Thai",
  "Indonesian",
  "Swedish",
  "Norwegian",
  "Danish",
  "Finnish",
  "Greek",
  "Hebrew",
  "Czech",
  "Romanian",
  "Hungarian",
  "Other",
] as const;

// Story statuses
export const STORY_STATUSES: StoryStatus[] = ["draft", "published", "completed"];

// Form validation constants
export const MAX_LENGTHS = {
  title: 100,
  subtitle: 200,
};

export const MAX_TAG_LENGTH = 30;
export const MAX_TAGS = 15;
export const MAX_CHARACTER_LENGTH = 100;
export const MAX_CHARACTER_DESCRIPTION_LENGTH = 500;
export const MAX_CHARACTERS = 20;

